module.exports = __webpack_public_path__ + "img/schnittkante_moosgruen_ral6005.18967652.jpg";